// extracted by mini-css-extract-plugin
export default {"container":"styles_container__nzW9g","button":"styles_button__xtGLx"};